import { MouseEvent } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { useDispatch } from 'react-redux';
import { checkDefaultWatchlist } from 'utils/watchlist';
import rootSlice from '../slice';
import slice from './slice';

const { actions } = slice;
const { actions: rootActions } = rootSlice;

type Props = {
  index: number;
  name: string;
  watchlistid: string;
};

function CollectionItem({
  index = 0,
  name = 'All Watchlist',
  watchlistid = null,
}: Props) {
  const dispatch = useDispatch();

  const onItemClick = () => {
    dispatch(
      rootActions.handleChangeActiveWatchlist({
        selected: watchlistid,
        name,
      }),
    );
    dispatch(actions.handleSetDropdown({ isOpen: false }));
  };

  const onEditItemClick = (e: MouseEvent) => {
    e.stopPropagation();
    dispatch(
      actions.handleSelectForModify({
        modalType: 'edit',
        selectedIndex: index,
      }),
    );
  };

  const onDeleteItemClick = (e: MouseEvent) => {
    e.stopPropagation();
    dispatch(
      actions.handleSelectForModify({
        modalType: 'delete',
        selectedIndex: index,
      }),
    );
  };

  const isEditable = !checkDefaultWatchlist(watchlistid);

  return (
    <Flex
      onClick={onItemClick}
      align="center"
      justify="space-between"
      style={{ cursor: 'pointer', width: '100%' }}
    >
      <Text width="100%" size="14px">
        {name}
      </Text>
      {isEditable && (
        <Flex align="center">
          <Iconmoon className="icon-toolbar_pencil" onClick={onEditItemClick} />
          <Iconmoon
            className="icon-trading_delete"
            hoverColor={color.sunsetOrange}
            onClick={onDeleteItemClick}
          />
        </Flex>
      )}
    </Flex>
  );
}

export default CollectionItem;
